<template>
  <div class="user-amount" v-if="(enableInterestingAnswer && hasUser) || answerRecoveryAmount">
    <template v-if="enableInterestingAnswer && hasUser">
      <div class="flex justify-center items-center">
        <div class="user-avatar">
          <van-image v-if="user.weixinHeadimgurl" round width="48px" height="48px" :src="user.weixinHeadimgurl" />
        </div>
        <div class="ml-2" v-if="user.weixinNickName">
          <div>
            <span class="text-theme-black-850">{{ user.weixinNickName }}</span>
          </div>
          <div class="text-medium text-theme-black-450">欢迎您参与活动</div>
        </div>
      </div>
    </template>
    <template v-if="answerRecoveryAmount">
      <div class="text-center" :class="{ 'w-full': !enableInterestingAnswer || !hasUser }">
        <span class="text-small">
          已有 <span class="text-theme text-medium">{{ answerRecoveryAmount }}</span> 人参与</span
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'UserAmount',
  computed: {
    answerRecoveryAmount() {
      const survey = this.$bus.survey
      if (!this.$bus.survey.otherSetting.enableAnswerCount) return
      return (survey.answerRecoveryAmount || 0).toString()
    },
    enableInterestingAnswer() {
      return this.$bus.survey.otherSetting.enableInterestingAnswer
    },
    user() {
      return this.$bus.user
    },
    hasUser() {
      const user = this.user || {}
      return user.weixinHeadimgurl || user.weixinNickName
    }
  }
}
</script>

<style scoped lang="scss">
.user-amount {
  background-color: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @apply rounded-small;
}
</style>
